<template>
    <div class="flex flex-row flex-wrap items-center justify-around py-16 px-10 lg:px-20 xl:px-32 w-full" id="aboutUs">
        <div class="flex flex-col items-center justify-center w-full tablet:w-1/2 py-5 tablet:pr-16 lg:pr-32">
            <h1 class="uppercase text-heading font-extrabold text-3xl tablet:text-4xl xl:text-5xl self-start pb-5">
                {{ tr('whoAreWe.title') }}
            </h1>
            <p class="text-text text-justify">
                {{ tr('whoAreWe.content') }}
            </p>
        </div>

        <div class="h-full w-full py-10 tablet:p-0 tablet:w-1/2">
            <img alt="" class="object-contain shadow-lg"
                 src="../assets/img/whoAreWe/building.jpg"
            >
        </div>
    </div>
</template>

<script>
import {Translatable} from '@/data/translations';

export default {
    name: 'WhoAreWe',
    mixins: [Translatable],
};
</script>
